import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { FC } from "react";

import { useStyles } from "./styles";

interface ISelectedCountComponentProps {
  selectedCount: number;
  isCouponEditable: boolean;
  onDeleteClick: () => void;
}

const SelectedCountComponent: FC<ISelectedCountComponentProps> = ({
  selectedCount,
  isCouponEditable,
  onDeleteClick
}) => {
  const classes = useStyles({});

  return (
    <div className={classes.container}>
      <div className={classes.countTextContainer}>
        {selectedCount} Unlock Code(s) Selected
      </div>
      <div className={classes.buttonsContainer}>
        <IconButton
          disabled={!isCouponEditable}
          color="primary"
          onClick={onDeleteClick}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default SelectedCountComponent;
